import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, ChangeDetectorRef, Input, OnDestroy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'al-accordion-item',
    templateUrl: './accordion-item.component.html',
    styleUrls: ['./accordion-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass],
})
export class AccordionItemComponent implements OnInit, OnDestroy {
	@Input() identifier?: string;

	public isOpen: boolean = false;
	public id: number = -1;
	public emitter: EventEmitter<number> = new EventEmitter();

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit(): void {}

	ngOnDestroy(): void {
		this.emitter.complete();
	}

	public setId(id: number) {
		this.id = id;
	}

	public setOpen(state: boolean): void {
		this.isOpen = state;
		this.cdr.detectChanges();
	}

	public toggle(): void {
		this.isOpen = !this.isOpen;
		this.cdr.detectChanges();
	}

	public emitCollapse(): void {
		this.emitter.next(this.id);
	}
}
